import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Collapse,
  Container,
  Nav,
  Navbar,
  NavbarToggler,
  NavItem,
  NavLink,
} from "reactstrap";

import logo from "../../assets/images/logo.png";

import ScrollspyNav from "./Scrollspy";

class NavbarPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMenu: false,
    };
  }

  toggle = () => {
    this.setState({ isOpenMenu: !this.state.isOpenMenu });
  };

  render() {
    let targetId = this.props.navItems.map((item) => {
      return item.idnm;
    });

    return (
      <React.Fragment>
        <Container>
          <Navbar
            expand="lg"
            fixed={this.props.top === true ? "top" : ""}
            className={
              this.props.navClass +
              " fixed-top navbar-custom sticky sticky-dark align-items-center"
            }
            id="navbar"
            container
            style={{ backgroundColor: "white" }}
          >
            <Link className="logo me-3" to="/">
              <img src={logo} alt="" height="40" />
            </Link>
            <NavbarToggler onClick={this.toggle}>
              {this.state.isOpenMenu ? (
                <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24}>
                  <path
                    fill="none"
                    stroke="#000"
                    strokeLinecap="round"
                    strokeWidth={1.5}
                    d="m8.464 15.535 7.072-7.07m-7.072 0 7.072 7.07"
                  />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" width={25} height={24}>
                  <path
                    fill="#000"
                    d="M3.563 6a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5h-16a.75.75 0 0 1-.75-.75m0 12a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5h-16a.75.75 0 0 1-.75-.75m.75-6.75a.75.75 0 0 0 0 1.5h16a.75.75 0 0 0 0-1.5z"
                  />
                </svg>
              )}
            </NavbarToggler>
            <Collapse
              id="navbarCollapse"
              isOpen={this.state.isOpenMenu}
              className=" navbar-collapse"
            >
              <ScrollspyNav
                scrollTargetIds={targetId}
                scrollDuration="800"
                headerBackground="true"
                activeNavClass="active"
                className="navbar-collapse justify-content-between"
              >
                <Nav className="navbar-nav navbar-center" id="navbar-navlist">
                  {this.props.navItems.map((item, key) => (
                    <NavItem
                      key={key}
                      className={item.navheading === "Home" ? "active" : ""}
                      style={{ backgroundColor: "white", color: "#8A8AA0" }}
                    >
                      <NavLink
                        className={item.navheading === "Home" ? "active" : ""}
                        style={{ backgroundColor: "white", color: "#8A8AA0" }}
                        href={"#" + item.idnm}
                      >
                        {item.navheading}
                      </NavLink>
                    </NavItem>
                  ))}
                </Nav>
                {/* <ul className="list-inline ml-auto menu-social-icon mb-0 py-2 py-lg-0">
                  <li className="list-inline-item ml-0">
                    <Link to="#" className="menu-social-link">
                      <FeatherIcon icon="facebook" className="icon-xs sw_1-5" />
                    </Link>
                  </li>
                  <li className="list-inline-item">
                    <Link to="#" className="menu-social-link">
                      <FeatherIcon icon="twitter" className="icon-xs sw_1-5" />
                    </Link>
                  </li>
                  <li className="list-inline-item">
                    <Link to="#" className="menu-social-link">
                      <FeatherIcon
                        icon="instagram"
                        className="icon-xs sw_1-5"
                      />
                    </Link>
                  </li>
                  <li className="list-inline-item mr-0">
                    <Link to="#" className="menu-social-link">
                      <FeatherIcon icon="linkedin" className="icon-xs sw_1-5" />
                    </Link>
                  </li>
                </ul> */}
                <NavLink
                  className="btn btn-primary f-18"
                  style={{ borderRadius: "44px" }}
                  href={"#contact-us"}
                >
                  Contact Us
                </NavLink>
              </ScrollspyNav>
            </Collapse>
          </Navbar>
        </Container>
      </React.Fragment>
    );
  }
}

export default NavbarPage;

// ---------------------------- OLD -----------------------------------------

// import React, { Component } from "react";
// import { Link } from "react-router-dom";
// import {
//   Collapse,
//   Container,
//   Nav,
//   Navbar,
//   NavbarToggler,
//   NavItem,
//   NavLink,
// } from "reactstrap";

// // Import Logo
// import logo from "../../assets/images/logo.png";

// //import icon

// import ScrollspyNav from "./Scrollspy";

// class NavbarPage extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       isOpenMenu: false,
//     };
//   }

//   render() {
//     let targetId = this.props.navItems.map((item) => {
//       return item.idnm;
//     });

//     return (
//       <React.Fragment>
//         <Container>
//           <Navbar
//             expand="lg"
//             fixed={this.props.top === true ? "top" : ""}
//             className={
//               this.props.navClass +
//               " fixed-top navbar-custom sticky sticky-dark align-items-center"
//             }
//             id="navbar"
//             container
//             style={{ backgroundColor: "white" }}
//           >
//             <Link className="logo me-3" to="/">
//               <img src={logo} alt="" height="40" />
//             </Link>
//             <NavbarToggler onClick={this.toggle}>
//               <span className="ti-menu"></span>
//             </NavbarToggler>
//             <Collapse
//               id="navbarCollapse"
//               isOpen={this.state.isOpenMenu}
//               className=" navbar-collapse"
//             >
//               <ScrollspyNav
//                 scrollTargetIds={targetId}
//                 scrollDuration="800"
//                 headerBackground="true"
//                 activeNavClass="active"
//                 className="navbar-collapse justify-content-between"
//               >
//                 <Nav className="navbar-nav navbar-center" id="navbar-navlist">
//                   {this.props.navItems.map((item, key) => (
//                     <NavItem
//                       key={key}
//                       className={item.navheading === "Home" ? "active" : ""}
//                       style={{ backgroundColor: "white", color: "#8A8AA0" }}
//                     >
//                       <NavLink
//                         className={item.navheading === "Home" ? "active" : ""}
//                         style={{ backgroundColor: "white", color: "#8A8AA0" }}
//                         href={"#" + item.idnm}
//                       >
//                         {item.navheading}
//                       </NavLink>
//                     </NavItem>
//                   ))}
//                 </Nav>
//                 {/* <ul className="list-inline ml-auto menu-social-icon mb-0 py-2 py-lg-0">
//                   <li className="list-inline-item ml-0">
//                     <Link to="#" className="menu-social-link">
//                       <FeatherIcon icon="facebook" className="icon-xs sw_1-5" />
//                     </Link>
//                   </li>
//                   <li className="list-inline-item">
//                     <Link to="#" className="menu-social-link">
//                       <FeatherIcon icon="twitter" className="icon-xs sw_1-5" />
//                     </Link>
//                   </li>
//                   <li className="list-inline-item">
//                     <Link to="#" className="menu-social-link">
//                       <FeatherIcon
//                         icon="instagram"
//                         className="icon-xs sw_1-5"
//                       />
//                     </Link>
//                   </li>
//                   <li className="list-inline-item mr-0">
//                     <Link to="#" className="menu-social-link">
//                       <FeatherIcon icon="linkedin" className="icon-xs sw_1-5" />
//                     </Link>
//                   </li>
//                 </ul> */}
//                 <NavLink
//                   className="btn btn-primary f-18"
//                   style={{ borderRadius: "44px" }}
//                   href={"#" + "contact-us"}
//                 >
//                   Contact Us
//                 </NavLink>
//               </ScrollspyNav>
//             </Collapse>
//           </Navbar>
//         </Container>
//       </React.Fragment>
//     );
//   }
// }
// // }
// export default NavbarPage;
